import { ADDRESS_LOOKUP_COPY } from './copy';

export interface DeriveStatusParams {
    isSearching: boolean;
    hasError: boolean;
    errorStatus?: number;
    isSuccess: boolean;
    resultsLength: number;
    filled: boolean;
    canQuery: boolean;
    disabled: boolean;
    hasContainer: boolean;
    minChars: number;
}

// Precedence, top to bottom: searching > 429 > other error > noMatches > filled > minChars.
export const deriveStatus = ({
    isSearching,
    hasError,
    errorStatus,
    isSuccess,
    resultsLength,
    filled,
    canQuery,
    disabled,
    hasContainer,
    minChars,
}: DeriveStatusParams): string => {
    if (isSearching) return ADDRESS_LOOKUP_COPY.searching;
    if (hasError && errorStatus === 429) return ADDRESS_LOOKUP_COPY.throttled;
    if (hasError) return ADDRESS_LOOKUP_COPY.unavailable;
    if (isSuccess && resultsLength === 0) return ADDRESS_LOOKUP_COPY.noMatches;
    if (filled) return ADDRESS_LOOKUP_COPY.filled;
    if (!canQuery && !disabled && !hasContainer) return ADDRESS_LOOKUP_COPY.minChars(minChars);
    return '';
};
